module.exports = __webpack_public_path__ + "img/frb6s.584be667.jpg";